import { fetchApi } from '@/std/api/fetchApi';

type PersonalizacaoInserirBody = Record<string, unknown>;

export function apiPersonalizacaoInserir(body: PersonalizacaoInserirBody) {
    return fetchApi({
        body,
        endpoint: 'Personalizacao/Inserir',
        method: 'post',
        schema: null,
    });
}
